(function () {

  class NSSmartCartDrawer {

    constructor(root) {

      this.root = root;

      this.config = this.getConfig();


      this.itemsEl = root.querySelector('[data-ns-cart-items]');

      this.emptyEl = root.querySelector('[data-ns-cart-empty]');

      this.subtotalEl = root.querySelector('[data-ns-cart-subtotal]');

      this.countTextEl = root.querySelector('[data-ns-cart-count-text]');

      this.toastEl = root.querySelector('[data-ns-cart-toast]');


      this.progressWrap = root.querySelector('[data-ns-progress-wrap]');

      this.progressFill = root.querySelector('[data-ns-progress-fill]');

      this.progressPercent = root.querySelector('[data-ns-progress-percent]');

      this.progressStepsEl = root.querySelector('[data-ns-progress-steps]');

      this.progressMessageEl = root.querySelector('[data-ns-progress-message]');


      this.discountsEl = root.querySelector('[data-ns-cart-discounts]');

      this.savingsBadgeEl = null;

      this.savingsBadgeWrap = null;


      this.productCache = {};

      this.savingsRequestId = 0;

      this.isBusy = false;

      this.scrollY = 0;


      this.lastAddSignature = '';

      this.lastAddTime = 0;


      window.NSSmartCartDrawerInstance = this;


      this.init();

    }


    init() {

      this.bindDrawerEvents();

      this.bindGlobalEvents();

      this.setupAnnouncementMarquee();

      this.setupCouponCopyButtons();

      this.setupCheckoutSavingsBadge();

      this.refreshCart(false);

    }


    getConfig() {

      const configEl = this.root.querySelector('[data-ns-cart-config]');


      if (!configEl) {

        return {

          rewardSteps: [],

          settings: {},

          currency: 'INR',

          moneyFormat: '₹{{amount}}',

          announcementInterval: 4000

        };

      }


      try {

        return JSON.parse(configEl.textContent);

      } catch (error) {

        console.error('NS Cart: Invalid config JSON', error);


        return {

          rewardSteps: [],

          settings: {},

          currency: 'INR',

          moneyFormat: '₹{{amount}}',

          announcementInterval: 4000

        };

      }

    }


    rootUrl() {

      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {

        return window.Shopify.routes.root;

      }


      return '/';

    }


    endpoint(path) {

      return this.rootUrl() + path;

    }


    bindDrawerEvents() {

      this.root.addEventListener('click', async (event) => {

        const closeButton = event.target.closest('[data-ns-cart-close]');

        if (closeButton) {

          event.preventDefault();

          this.close();

          return;

        }


        const upsellButton = event.target.closest('[data-ns-upsell-add]');

        if (upsellButton) {

          event.preventDefault();

          await this.addUpsell(upsellButton);

          return;

        }


        const copyDiscountButton = event.target.closest('[data-ns-apply-discount]');

        if (copyDiscountButton) {

          event.preventDefault();

          await this.copyDiscountCode(copyDiscountButton);

          return;

        }


        const minusButton = event.target.closest('[data-ns-qty-minus]');

        if (minusButton) {

          event.preventDefault();


          const line = minusButton.closest('[data-ns-cart-line]');

          const input = line.querySelector('[data-ns-qty-input]');

          const nextQty = Math.max(0, Number(input.value || 1) - 1);


          await this.changeQuantity(line.dataset.lineKey, nextQty);

          return;

        }


        const plusButton = event.target.closest('[data-ns-qty-plus]');

        if (plusButton) {

          event.preventDefault();


          const line = plusButton.closest('[data-ns-cart-line]');

          const input = line.querySelector('[data-ns-qty-input]');

          const nextQty = Number(input.value || 1) + 1;


          await this.changeQuantity(line.dataset.lineKey, nextQty);

          return;

        }


        const removeButton = event.target.closest('[data-ns-remove]');

        if (removeButton) {

          event.preventDefault();


          const line = removeButton.closest('[data-ns-cart-line]');

          await this.changeQuantity(line.dataset.lineKey, 0);

        }

      });


      this.root.addEventListener('change', async (event) => {

        const qtyInput = event.target.closest('[data-ns-qty-input]');

        if (!qtyInput) return;


        const line = qtyInput.closest('[data-ns-cart-line]');

        const nextQty = Math.max(0, Number(qtyInput.value || 0));


        await this.changeQuantity(line.dataset.lineKey, nextQty);

      });


      document.addEventListener('keydown', (event) => {

        if (event.key === 'Escape' && this.root.classList.contains('is-open')) {

          this.close();

        }

      });

    }


    bindGlobalEvents() {

      if (window.NSSmartCartDrawerGlobalBound) return;


      window.NSSmartCartDrawerGlobalBound = true;


      document.addEventListener(

        'click',

        async (event) => {

          const instance = window.NSSmartCartDrawerInstance;

          if (!instance) return;


          const addToCartForm = instance.getAddToCartFormFromClick(event);


          if (addToCartForm) {

            event.preventDefault();

            event.stopPropagation();


            if (typeof event.stopImmediatePropagation === 'function') {

              event.stopImmediatePropagation();

            }


            await instance.handleAddToCartForm(addToCartForm);

            return;

          }


          if (!instance.isCartIconTrigger(event)) return;


          event.preventDefault();

          event.stopPropagation();


          if (typeof event.stopImmediatePropagation === 'function') {

            event.stopImmediatePropagation();

          }


          instance.closeNativeCartElements();

          await instance.refreshCart(true);

        },

        true

      );


      document.addEventListener(

        'submit',

        async (event) => {

          const instance = window.NSSmartCartDrawerInstance;

          const form = event.target;


          if (!instance || !form || !form.matches('form[action*="/cart/add"]')) return;

          if (form.closest('[data-ns-cart-drawer]')) return;

          if (form.hasAttribute('data-ns-skip-cart-drawer')) return;


          event.preventDefault();

          event.stopPropagation();


          if (typeof event.stopImmediatePropagation === 'function') {

            event.stopImmediatePropagation();

          }


          await instance.handleAddToCartForm(form);

        },

        true

      );

    }


    getAddToCartFormFromClick(event) {

      const target = event.target;

      if (!target) return null;


      if (target.closest('[data-ns-cart-drawer]')) return null;


      const trigger = target.closest(

        [

          'button[type="submit"]',

          'input[type="submit"]',

          'button[name="add"]',

          '[name="add"]',

          '.product-form__submit',

          '[data-add-to-cart]',

          '[data-product-form-submit]',

          '[type="submit"]'

        ].join(',')

      );


      if (!trigger) return null;


      const form = trigger.closest('form[action*="/cart/add"]');

      if (!form) return null;


      if (form.hasAttribute('data-ns-skip-cart-drawer')) return null;


      return form;

    }


    isCartIconTrigger(event) {

      const target = event.target;


      if (!target) return false;

      if (target.closest('[data-ns-cart-drawer]')) return false;

      if (target.closest('form[action*="/cart/add"]')) return false;


      const cartHref = target.closest('a[href]');

      if (cartHref) {

        try {

          const url = new URL(cartHref.href, window.location.origin);

          const cleanPath = url.pathname.replace(/\/$/, '');


          if (cleanPath.endsWith('/cart')) {

            return true;

          }

        } catch (error) {

          /* ignore invalid urls */

        }

      }


      const possibleTrigger = target.closest(

        [

          'a',

          'button',

          'summary',

          '[role="button"]',

          '[aria-controls]',

          '[data-cart-trigger]',

          '[data-cart-drawer-trigger]',

          '#cart-icon-bubble',

          '.cart-icon-bubble',

          '.header__icon--cart',

          '.header-actions__action',

          'cart-icon',

          'cart-icon-bubble'

        ].join(',')

      );


      if (!possibleTrigger) return false;


      const text = [

        possibleTrigger.id,

        typeof possibleTrigger.className === 'string' ? possibleTrigger.className : '',

        possibleTrigger.getAttribute('aria-label'),

        possibleTrigger.getAttribute('aria-controls'),

        possibleTrigger.getAttribute('data-action'),

        possibleTrigger.getAttribute('data-cart-trigger'),

        possibleTrigger.getAttribute('data-cart-drawer-trigger')

      ]

        .filter(Boolean)

        .join(' ')

        .toLowerCase();


      if (!text.includes('cart')) return false;

      if (text.includes('add to cart')) return false;

      if (text.includes('add-to-cart')) return false;

      if (text.includes('product-form')) return false;


      return true;

    }


    closeNativeCartElements() {

      const selectors = [

        'cart-drawer',

        'cart-notification',

        '#cart-drawer',

        '.cart-drawer',

        '.cart-notification',

        '[data-cart-drawer]',

        '[aria-modal="true"][id*="cart"]'

      ];


      document.querySelectorAll(selectors.join(',')).forEach((el) => {

        if (el.closest('[data-ns-cart-drawer]')) return;


        el.classList.remove('active');

        el.classList.remove('animate');

        el.classList.remove('is-empty');

        el.removeAttribute('open');

        el.setAttribute('aria-hidden', 'true');


        if (el.style) {

          el.style.display = 'none';

          el.style.visibility = 'hidden';

          el.style.opacity = '0';

          el.style.pointerEvents = 'none';

        }

      });


      document.body.classList.remove('overflow-hidden');

    }


    setupAnnouncementMarquee() {

      const container = this.root.querySelector('[data-ns-announcements]');

      if (!container) return;

      if (container.dataset.nsMarqueeReady === 'true') return;


      const announcements = Array.from(container.querySelectorAll('[data-ns-announcement]'));

      if (!announcements.length) return;


      container.dataset.nsMarqueeReady = 'true';


      const track = document.createElement('div');

      const groupOne = document.createElement('div');

      const groupTwo = document.createElement('div');


      track.className = 'ns-cart__announcement-track';

      groupOne.className = 'ns-cart__announcement-group';

      groupTwo.className = 'ns-cart__announcement-group';

      groupTwo.setAttribute('aria-hidden', 'true');


      announcements.forEach((announcement) => {

        announcement.classList.remove('is-active');

        groupOne.appendChild(announcement);

      });


      announcements.forEach((announcement) => {

        const clone = announcement.cloneNode(true);

        clone.removeAttribute('id');

        groupTwo.appendChild(clone);

      });


      container.innerHTML = '';

      track.appendChild(groupOne);

      track.appendChild(groupTwo);

      container.appendChild(track);


      const totalTextLength = announcements

        .map((announcement) => announcement.textContent.trim().length)

        .reduce((sum, length) => sum + length, 0);


      const duration = Math.max(4.8, Math.min(11, totalTextLength * 0.14));

      track.style.animationDuration = `${duration}s`;

    }


    setupCouponCopyButtons() {

      const buttons = this.root.querySelectorAll('[data-ns-apply-discount]');


      buttons.forEach((button) => {

        button.textContent = 'Copy code';

        button.setAttribute('aria-label', 'Copy discount code');

        button.setAttribute('type', 'button');

      });

    }


    setupCheckoutSavingsBadge() {

      const checkout = this.root.querySelector('[data-ns-checkout]');

      if (!checkout) return;


      const existingWrap = checkout.closest('.ns-cart__checkout-wrap');


      if (existingWrap) {

        this.savingsBadgeWrap = existingWrap;

        this.savingsBadgeEl = existingWrap.querySelector('[data-ns-savings-badge]');

        return;

      }


      const wrap = document.createElement('div');

      const badge = document.createElement('div');


      wrap.className = 'ns-cart__checkout-wrap';

      badge.className = 'ns-cart__savings-badge';

      badge.setAttribute('data-ns-savings-badge', '');

      badge.hidden = true;


      checkout.parentNode.insertBefore(wrap, checkout);

      wrap.appendChild(badge);

      wrap.appendChild(checkout);


      this.savingsBadgeWrap = wrap;

      this.savingsBadgeEl = badge;

    }


    async copyDiscountCode(button) {

      const code = button.dataset.discountCode;

      if (!code) return;


      const originalText = button.dataset.originalText || 'Copy code';


      try {

        await this.copyText(code);


        button.dataset.originalText = originalText;

        button.textContent = 'Copied';

        button.classList.add('is-copied');


        this.showToast(`${code} copied`);


        clearTimeout(button._nsCopyTimer);


        button._nsCopyTimer = setTimeout(() => {

          button.textContent = originalText;

          button.classList.remove('is-copied');

        }, 1600);

      } catch (error) {

        console.error('NS Cart copy error:', error);

        this.showToast('Could not copy code');

      }

    }


    async copyText(text) {

      if (navigator.clipboard && window.isSecureContext) {

        await navigator.clipboard.writeText(text);

        return;

      }


      const textarea = document.createElement('textarea');

      textarea.value = text;

      textarea.setAttribute('readonly', '');

      textarea.style.position = 'fixed';

      textarea.style.top = '-9999px';

      textarea.style.left = '-9999px';


      document.body.appendChild(textarea);

      textarea.select();


      const success = document.execCommand('copy');

      document.body.removeChild(textarea);


      if (!success) {

        throw new Error('Fallback copy failed');

      }

    }


    async handleAddToCartForm(form) {

      if (!form) return;

      if (form.dataset.nsCartProcessing === 'true') return;


      if (typeof form.checkValidity === 'function' && !form.checkValidity()) {

        form.reportValidity();

        return;

      }


      const formData = new FormData(form);


      if (!formData.get('quantity')) {

        formData.set('quantity', '1');

      }


      const variantId = String(formData.get('id') || '');

      const quantity = String(formData.get('quantity') || '1');

      const signature = `${variantId}:${quantity}`;

      const now = Date.now();


      if (this.lastAddSignature === signature && now - this.lastAddTime < 900) {

        return;

      }


      this.lastAddSignature = signature;

      this.lastAddTime = now;

      form.dataset.nsCartProcessing = 'true';


      const submitButton = form.querySelector('[type="submit"], button:not([type])');

      this.setButtonLoading(submitButton, true, 'Adding...');


      try {

        await this.cartRequest('cart/add.js', {

          method: 'POST',

          body: formData

        });


        await this.refreshCart(true);

        this.showToast('Product added to cart');

      } catch (error) {

        console.error('NS Cart add error:', error);

        this.showToast(error.message || 'Could not add product');

        this.open();

      } finally {

        this.setButtonLoading(submitButton, false);


        setTimeout(() => {

          delete form.dataset.nsCartProcessing;

        }, 650);

      }

    }


    async addUpsell(button) {

      if (this.isBusy || button.disabled) return;


      const variantId = button.dataset.variantId;

      if (!variantId) return;


      this.setButtonLoading(button, true, 'Adding...');


      try {

        await this.cartRequest('cart/add.js', {

          method: 'POST',

          headers: {

            Accept: 'application/json',

            'Content-Type': 'application/json'

          },

          body: JSON.stringify({

            id: Number(variantId),

            quantity: 1

          })

        });


        await this.refreshCart(true);

        this.showToast('Added to cart');

      } catch (error) {

        console.error('NS Cart upsell error:', error);

        this.showToast(error.message || 'Could not add product');

      } finally {

        this.setButtonLoading(button, false);

      }

    }


    async changeQuantity(lineKey, quantity) {

      if (!lineKey) return;


      try {

        const cart = await this.cartRequest('cart/change.js', {

          method: 'POST',

          headers: {

            Accept: 'application/json',

            'Content-Type': 'application/json'

          },

          body: JSON.stringify({

            id: lineKey,

            quantity: quantity

          })

        });


        this.render(cart);

        this.showToast(quantity === 0 ? 'Item removed' : 'Cart updated');

      } catch (error) {

        console.error('NS Cart quantity error:', error);

        this.showToast(error.message || 'Could not update cart');

      }

    }


    async refreshCart(openAfterRender) {

      try {

        const cart = await this.fetchCart();

        this.render(cart);


        if (openAfterRender) {

          this.open();

        }

      } catch (error) {

        console.error('NS Cart fetch error:', error);

      }

    }


    async fetchCart() {

      return this.cartRequest('cart.js', {

        method: 'GET',

        headers: {

          Accept: 'application/json'

        }

      });

    }


    async cartRequest(path, options) {

      this.isBusy = true;

      this.root.classList.add('ns-cart__loading');


      try {

        const response = await fetch(this.endpoint(path), options);


        let data = null;


        try {

          data = await response.json();

        } catch (error) {

          data = null;

        }


        if (!response.ok) {

          const message =

            data && (data.description || data.message || data.status)

              ? data.description || data.message || data.status

              : 'Cart request failed';


          throw new Error(message);

        }


        return data;

      } finally {

        this.isBusy = false;

        this.root.classList.remove('ns-cart__loading');

      }

    }


    render(cart) {

      if (!cart) return;


      this.renderCount(cart);

      this.renderItems(cart);

      this.renderProgress(cart);

      this.renderSubtotal(cart);

      this.renderDiscounts(cart);

      this.updateGlobalCartCount(cart);

      this.updateSavingsBadge(cart);

      this.dispatchCartEvents(cart);


      document.dispatchEvent(new CustomEvent('ns:cart:updated', { detail: { cart } }));

    }


    renderCount(cart) {

      const count = Number(cart.item_count || 0);


      if (!this.countTextEl) return;


      if (count === 0) {

        this.countTextEl.textContent = this.config.settings.emptySubtitle || 'Your cart is currently empty';

      } else if (count === 1) {

        this.countTextEl.textContent = `1 ${this.config.settings.itemText || 'item in your cart'}`;

      } else {

        this.countTextEl.textContent = `${count} ${this.config.settings.itemsText || 'items in your cart'}`;

      }

    }


    renderItems(cart) {

      const items = cart.items || [];

      const isEmpty = items.length === 0;


      if (this.emptyEl) {

        this.emptyEl.hidden = !isEmpty;

      }


      if (!this.itemsEl) return;


      if (isEmpty) {

        this.itemsEl.innerHTML = '';

        return;

      }


      this.itemsEl.innerHTML = items.map((item) => this.itemHTML(item)).join('');

    }


    itemHTML(item) {

      const image = item.image || '';

      const title = this.escapeHTML(item.product_title || item.title || '');

      const url = item.url || '#';


      const variantTitle =

        item.variant_title && item.variant_title !== 'Default Title'

          ? `<div class="ns-cart__item-variant">${this.escapeHTML(item.variant_title)}</div>`

          : '';


      const properties = this.propertiesHTML(item.properties);

      const finalPrice = this.formatMoney(item.final_price || item.price || 0);


      const originalPrice =

        item.original_price && item.final_price && item.original_price > item.final_price

          ? `<s>${this.formatMoney(item.original_price)}</s>`

          : '';


      return `

        <article class="ns-cart__item" data-ns-cart-line data-line-key="${this.escapeAttr(item.key)}">

          <a href="${this.escapeAttr(url)}" class="ns-cart__item-image">

            ${image ? `<img src="${this.escapeAttr(image)}" alt="${title}" loading="lazy">` : ''}

          </a>


          <div class="ns-cart__item-info">

            <a href="${this.escapeAttr(url)}" class="ns-cart__item-title">${title}</a>

            ${variantTitle}

            ${properties}


            <div class="ns-cart__item-actions">

              <div class="ns-cart__qty">

                <button type="button" data-ns-qty-minus aria-label="Decrease quantity">−</button>

                <input

                  type="number"

                  min="0"

                  value="${Number(item.quantity || 1)}"

                  data-ns-qty-input

                  aria-label="Quantity"

                >

                <button type="button" data-ns-qty-plus aria-label="Increase quantity">+</button>

              </div>


              <div class="ns-cart__item-price">

                <span>${finalPrice}</span>

                ${originalPrice}

              </div>

            </div>

          </div>


          <button type="button" class="ns-cart__remove" data-ns-remove aria-label="Remove item">

            Remove

          </button>

        </article>

      `;

    }


    propertiesHTML(properties) {

      if (!properties || typeof properties !== 'object') return '';


      const rows = Object.keys(properties)

        .filter((key) => key && key.charAt(0) !== '_' && properties[key])

        .map((key) => `${this.escapeHTML(key)}: ${this.escapeHTML(String(properties[key]))}`);


      if (!rows.length) return '';


      return `<div class="ns-cart__item-properties">${rows.join('<br>')}</div>`;

    }


    renderProgress(cart) {

      if (!this.progressWrap) return;


      const steps = Array.isArray(this.config.rewardSteps)

        ? this.config.rewardSteps

            .filter((step) => Number(step.threshold) > 0)

            .sort((a, b) => Number(a.threshold) - Number(b.threshold))

        : [];


      if (!steps.length) return;


      const subtotal = Number(cart.total_price || 0) / 100;

      const lastThreshold = Number(steps[steps.length - 1].threshold);

      const percent = lastThreshold > 0 ? Math.min((subtotal / lastThreshold) * 100, 100) : 0;


      if (this.progressFill) {

        this.progressFill.style.width = `${percent}%`;

      }


      if (this.progressPercent) {

        this.progressPercent.textContent = `${Math.round(percent)}%`;

      }


      if (this.progressStepsEl) {

        this.progressStepsEl.innerHTML = steps

          .map((step) => {

            const threshold = Number(step.threshold);

            const isUnlocked = subtotal >= threshold;


            const statusText = isUnlocked

              ? this.config.settings.unlockedLabel || 'Unlocked'

              : this.config.settings.lockedLabel || 'Locked';


            return `

              <div class="ns-cart__reward-step ${isUnlocked ? 'is-unlocked' : ''}">

                <span class="ns-cart__reward-dot">${isUnlocked ? '✓' : this.escapeHTML(step.icon || '•')}</span>

                <span class="ns-cart__reward-step-title">${this.escapeHTML(step.title || '')}</span>

                <span class="ns-cart__reward-step-status">${this.escapeHTML(statusText)}</span>

              </div>

            `;

          })

          .join('');

      }


      if (this.progressMessageEl) {

        const nextStep = steps.find((step) => subtotal < Number(step.threshold));


        if (nextStep) {

          const remaining = Number(nextStep.threshold) - subtotal;

          const remainingMoney = this.formatMoney(Math.ceil(remaining * 100));


          this.progressMessageEl.innerHTML = `${this.escapeHTML(

            this.config.settings.remainingPrefix || 'You are'

          )} ${remainingMoney} ${this.escapeHTML(

            this.config.settings.remainingMiddle || 'away from'

          )} <strong>${this.escapeHTML(nextStep.title || 'this reward')}</strong> ${this.escapeHTML(

            this.config.settings.remainingSuffix || ''

          )}`.trim();

        } else {

          this.progressMessageEl.textContent =

            this.config.settings.allUnlockedMessage || 'You have unlocked all rewards.';

        }

      }

    }


    renderSubtotal(cart) {

      if (!this.subtotalEl) return;

      this.subtotalEl.textContent = this.formatMoney(cart.total_price || 0);

    }


    renderDiscounts(cart) {

      if (!this.discountsEl) return;


      const applications = cart.cart_level_discount_applications || [];


      if (!applications.length) {

        this.discountsEl.hidden = true;

        this.discountsEl.innerHTML = '';

        return;

      }


      this.discountsEl.hidden = false;


      this.discountsEl.innerHTML = applications

        .map((discount) => {

          const title = discount.title || 'Discount';

          const amount = discount.total_allocated_amount || 0;


          return `

            <div class="ns-cart__discount-pill">

              <span>${this.escapeHTML(title)}</span>

              <strong>-${this.formatMoney(amount)}</strong>

            </div>

          `;

        })

        .join('');

    }


    updateGlobalCartCount(cart) {

      const count = Number(cart.item_count || 0);

      const visibleText = String(count);

      const accessibleText = count === 1 ? '1 item' : `${count} items`;


      const preferredTrigger =

        document.querySelector('header #cart-icon-bubble') ||

        document.querySelector('header .header__icon--cart') ||

        document.querySelector('header .cart-icon-bubble') ||

        document.querySelector('header a[href="/cart"]') ||

        document.querySelector('header a[href$="/cart"]') ||

        document.querySelector('.header #cart-icon-bubble') ||

        document.querySelector('.header .header__icon--cart') ||

        document.querySelector('.header .cart-icon-bubble') ||

        document.querySelector('.header a[href="/cart"]') ||

        document.querySelector('.header a[href$="/cart"]');


      if (!preferredTrigger) return;

      if (preferredTrigger.closest('[data-ns-cart-drawer]')) return;


      this.removeAllHeaderCartCountDuplicates(preferredTrigger);


      let bubble = preferredTrigger.querySelector('.cart-count-bubble');


      if (!bubble && count > 0) {

        bubble = document.createElement('div');

        bubble.className = 'cart-count-bubble';

        preferredTrigger.appendChild(bubble);

      }


      if (!bubble) return;


      bubble.innerHTML = `

        <span aria-hidden="true">${count > 0 ? this.escapeHTML(visibleText) : ''}</span>

        <span class="visually-hidden">${count > 0 ? this.escapeHTML(accessibleText) : 'Cart is empty'}</span>

      `;


      if (count > 0) {

        bubble.hidden = false;

        bubble.removeAttribute('hidden');

        bubble.setAttribute('aria-hidden', 'false');

        bubble.classList.remove('hidden', 'is-hidden', 'empty', 'is-empty');


        bubble.style.display = '';

        bubble.style.visibility = '';

        bubble.style.opacity = '';

        bubble.style.pointerEvents = '';

      } else {

        bubble.hidden = true;

        bubble.setAttribute('hidden', '');

        bubble.setAttribute('aria-hidden', 'true');

        bubble.classList.add('hidden', 'is-hidden', 'empty', 'is-empty');


        bubble.style.display = 'none';

        bubble.style.visibility = 'hidden';

        bubble.style.opacity = '0';

        bubble.style.pointerEvents = 'none';

      }


      const currentLabel = preferredTrigger.getAttribute('aria-label');


      if (currentLabel && currentLabel.toLowerCase().includes('cart')) {

        preferredTrigger.setAttribute('aria-label', count > 0 ? `Cart, ${accessibleText}` : 'Cart');

      }


      preferredTrigger.classList.toggle('ns-cart-has-items', count > 0);

      preferredTrigger.classList.toggle('ns-cart-is-empty', count === 0);

    }


    removeAllHeaderCartCountDuplicates(preferredTrigger) {

      const header =

        preferredTrigger.closest('header') ||

        preferredTrigger.closest('.header') ||

        document.querySelector('header') ||

        document;


      header.querySelectorAll('.cart-count-bubble').forEach((bubble) => {

        if (bubble.closest('[data-ns-cart-drawer]')) return;

        if (preferredTrigger.contains(bubble)) return;

        bubble.remove();

      });


      const preferredBubbles = Array.from(preferredTrigger.querySelectorAll('.cart-count-bubble'));


      preferredBubbles.forEach((bubble, index) => {

        if (index > 0) {

          bubble.remove();

        }

      });


      this.removeLooseHeaderCartNumbers(preferredTrigger);


      Array.from(header.childNodes).forEach((node) => {

        if (node.nodeType !== Node.TEXT_NODE) return;


        const text = node.textContent.trim();


        if (/^\d+$/.test(text)) {

          node.remove();

        }

      });

    }


    removeLooseHeaderCartNumbers(trigger) {

      if (!trigger) return;


      Array.from(trigger.childNodes).forEach((node) => {

        if (node.nodeType !== Node.TEXT_NODE) return;


        const text = node.textContent.trim();


        if (/^\d+$/.test(text)) {

          node.remove();

        }

      });


      Array.from(trigger.children).forEach((child) => {

        if (child.classList && child.classList.contains('cart-count-bubble')) return;

        if (child.classList && child.classList.contains('svg-wrapper')) return;

        if (child.classList && child.classList.contains('visually-hidden')) return;

        if (child.matches && child.matches('svg, path, g, use')) return;


        const childText = child.textContent.trim();


        if (/^\d+$/.test(childText)) {

          child.remove();

        }

      });


      if (trigger.parentElement) {

        Array.from(trigger.parentElement.childNodes).forEach((node) => {

          if (node === trigger) return;


          if (node.nodeType === Node.TEXT_NODE) {

            const text = node.textContent.trim();


            if (/^\d+$/.test(text)) {

              node.remove();

            }

          }


          if (node.nodeType === Node.ELEMENT_NODE) {

            const text = node.textContent.trim();


            if (/^\d+$/.test(text) && !node.matches('svg, path, g, use')) {

              node.remove();

            }

          }

        });

      }

    }


    dispatchCartEvents(cart) {

      const eventDetail = { cart };


      document.dispatchEvent(new CustomEvent('cart:updated', { detail: eventDetail }));

      document.dispatchEvent(new CustomEvent('cart:change', { detail: eventDetail }));

      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { detail: eventDetail }));

      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { detail: eventDetail }));

    }


    async updateSavingsBadge(cart) {

      if (!this.savingsBadgeEl || !this.savingsBadgeWrap) return;


      const requestId = ++this.savingsRequestId;


      try {

        const savedCents = await this.calculateTotalSavings(cart);


        if (requestId !== this.savingsRequestId) return;


        if (savedCents > 0) {

          this.savingsBadgeEl.textContent = `${this.formatMoney(savedCents)} Saved so far!`;

          this.savingsBadgeEl.hidden = false;

          this.savingsBadgeWrap.classList.add('has-savings');

        } else {

          this.savingsBadgeEl.hidden = true;

          this.savingsBadgeWrap.classList.remove('has-savings');

        }

      } catch (error) {

        console.error('NS Cart savings error:', error);

        this.savingsBadgeEl.hidden = true;

        this.savingsBadgeWrap.classList.remove('has-savings');

      }

    }


    async calculateTotalSavings(cart) {

      const items = cart.items || [];

      let saved = 0;

      let visibleLineTotal = 0;


      for (const item of items) {

        const quantity = Number(item.quantity || 1);

        const finalLinePrice = Number(item.final_line_price || item.line_price || 0);

        const originalLinePrice = Number(item.original_line_price || 0);

        let compareAtPrice = Number(item.compare_at_price || item.variant_compare_at_price || 0);


        visibleLineTotal += finalLinePrice;


        if (!compareAtPrice && item.handle && item.variant_id) {

          const product = await this.getProductData(item.handle);

          const variant = product && product.variants

            ? product.variants.find((v) => Number(v.id) === Number(item.variant_id))

            : null;


          if (variant && variant.compare_at_price) {

            compareAtPrice = Number(variant.compare_at_price);

          }

        }


        if (compareAtPrice && compareAtPrice > Number(item.final_price || item.price || 0)) {

          saved += Math.max(0, compareAtPrice * quantity - finalLinePrice);

        } else if (originalLinePrice && originalLinePrice > finalLinePrice) {

          saved += Math.max(0, originalLinePrice - finalLinePrice);

        }

      }


      const cartLevelSavings = Math.max(0, visibleLineTotal - Number(cart.total_price || 0));

      saved += cartLevelSavings;


      return Math.round(saved);

    }


    async getProductData(handle) {

      if (!handle) return null;


      if (this.productCache[handle]) {

        return this.productCache[handle];

      }


      const response = await fetch(this.endpoint(`products/${encodeURIComponent(handle)}.js`), {

        headers: {

          Accept: 'application/json'

        }

      });


      if (!response.ok) {

        return null;

      }


      const product = await response.json();

      this.productCache[handle] = product;


      return product;

    }


    formatMoney(cents) {

      const amount = Number(cents || 0);


      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {

        return window.Shopify.formatMoney(amount, this.config.moneyFormat);

      }


      try {

        return new Intl.NumberFormat(undefined, {

          style: 'currency',

          currency: this.config.currency || 'INR',

          maximumFractionDigits: 2

        }).format(amount / 100);

      } catch (error) {

        return `₹${(amount / 100).toFixed(2)}`;

      }

    }


    open() {

      this.closeNativeCartElements();


      if (this.root.classList.contains('is-open')) return;


      this.lockPageScroll();


      this.root.classList.add('is-open');

      document.documentElement.classList.add('ns-cart-html-open');

      document.body.classList.add('ns-cart-open');


      const closeButton = this.root.querySelector('[data-ns-cart-close]');

      if (closeButton) {

        setTimeout(() => closeButton.focus(), 50);

      }

    }


    close() {

      if (!this.root.classList.contains('is-open')) return;


      this.root.classList.remove('is-open');

      document.documentElement.classList.remove('ns-cart-html-open');

      document.body.classList.remove('ns-cart-open');


      this.unlockPageScroll();

    }


    lockPageScroll() {

      this.scrollY = window.scrollY || document.documentElement.scrollTop || 0;


      document.body.style.position = 'fixed';

      document.body.style.top = `-${this.scrollY}px`;

      document.body.style.left = '0';

      document.body.style.right = '0';

      document.body.style.width = '100%';

      document.body.style.overflow = 'hidden';

    }


    unlockPageScroll() {

      const y = this.scrollY || 0;


      document.body.style.position = '';

      document.body.style.top = '';

      document.body.style.left = '';

      document.body.style.right = '';

      document.body.style.width = '';

      document.body.style.overflow = '';


      window.scrollTo(0, y);

    }


    showToast(message) {

      if (!this.toastEl || !message) return;


      this.toastEl.textContent = message;

      this.toastEl.hidden = false;


      clearTimeout(this.toastTimer);


      this.toastTimer = setTimeout(() => {

        this.toastEl.hidden = true;

      }, 2200);

    }


    setButtonLoading(button, isLoading, loadingText) {

      if (!button) return;


      if (isLoading) {

        button.dataset.originalText = button.textContent;

        button.textContent = loadingText || 'Loading...';

        button.disabled = true;

      } else {

        button.textContent = button.dataset.originalText || button.textContent;

        button.disabled = false;

      }

    }


    escapeHTML(value) {

      return String(value || '')

        .replace(/&/g, '&amp;')

        .replace(/</g, '&lt;')

        .replace(/>/g, '&gt;')

        .replace(/"/g, '&quot;')

        .replace(/'/g, '&#039;');

    }


    escapeAttr(value) {

      return this.escapeHTML(value).replace(/`/g, '&#096;');

    }

  }


  function initNSSmartCartDrawer() {

    const drawer = document.querySelector('[data-ns-cart-drawer]');


    if (!drawer) return;

    if (drawer.dataset.nsInitialized === 'true') return;


    drawer.dataset.nsInitialized = 'true';

    new NSSmartCartDrawer(drawer);

  }


  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', initNSSmartCartDrawer);

  } else {

    initNSSmartCartDrawer();

  }


  document.addEventListener('shopify:section:load', initNSSmartCartDrawer);

})();



